import React, { Component } from 'react';

export default class Message extends Component {
    constructor(props) {
        super(props);
        
    }
  render() {
    return (
        <>
        
        <div className={this.props.own ? "d-flex align-items-start justify-content-end  pb-2": "d-flex align-items-start pb-2 "}>
          {!this.props.own && (
          <img src="/imgs/dash/conv_circle.svg" className="discuss__circle mr-2" alt="" />
          )}
          <div className="d-flex flex-column">
            {!this.props.own && (
            <span className="msg__profile">{this.props.user}</span>
            )}
            <span className={this.props.own ? "message mine": "message coming"}>
            {this.props.message.includes("http") ? (
              <a  href={this.props.message} download>
                <img src={this.props.message} width="200px" height="200px" alt="" srcset="" />
              </a>
            ): (this.props.message)}
             
            </span>
          </div>
          {this.props.own && (
          <img src="/imgs/dash/conv_circle.svg" className="discuss__circle ml-2" alt="" />
          )}
        </div>
        </>
      
     
    
    
    );
  }
}
